const uploadFields = document.querySelectorAll<HTMLElement>('#id_layers');
const uploadedFiles = document.querySelector('#files');
const fileInputs = document.querySelector('.custom-file-input');

if (uploadFields) {
    let files: string[] = [];
    if (uploadedFiles) {
        files = JSON.parse(uploadedFiles.textContent || '');
    }
    import('../LayerUpload').then(function (LayerUpload) {
        uploadFields.forEach((field) => LayerUpload.default(field, files));
    });
}

if (fileInputs) {
    import('../FileInput').then(function (FileInput) {
        FileInput.default(fileInputs);
    });
}
